module Client.Components.ContactEntry

open Client
open Client.Services
open Shared
open global.Elmish
open Fable.Core.JsInterop
open System
open Thoth.Fetch
open Thoth.Json
open Fetch.Types
open Feliz
open Feliz.MaterialUI
open Fable.MaterialUI.Icons
open Fable.MaterialUI.MaterialDesignIcons
open Feliz.SweetAlert
open Feliz.UseElmish
open Fable.Core.Experimental
open Fable.Core.JS
open CustomerDexImaging.Models

let strOption (s : string) = if String.IsNullOrWhiteSpace s then None else Some s
type FieldState =
  { Validate : bool
    FieldValue : string option } with
    static member defaultValue =
      { Validate = false; FieldValue = None }
    static member init v =
      { Validate = false; FieldValue = v }
    member this.setValue v =
      { Validate = true; FieldValue = v }

type EntryState =
  { FirstName : FieldState
    MiddleName : string option
    LastName : FieldState
    Phone : string option
    Email : string option } with
    member this.validate () =
      match this.FirstName.FieldValue, this.LastName.FieldValue, this.Phone, this.Email with
      | Some f, Some l, Some p, Some e ->
        { AddContactRequest.FirstName = f
          MiddleName = this.MiddleName |> Option.defaultValue ""
          LastName = l
          Phone = p
          Email = e } |> Ok
      | _ -> Error "Please ensure all required fields are populated."
    member this.isValid () =
      match this.validate() with
      | Ok _ -> true
      | Error _ -> false
    static member defaultValue =
      { FirstName = FieldState.defaultValue
        MiddleName = None
        LastName = FieldState.defaultValue
        Phone = None
        Email = None }

let view = React.functionComponent (fun (inputProps: {| initialEmail : string option; returnResult: AddContactRequest option -> unit; |}) ->
  let state, setState = React.useState({ EntryState.defaultValue with Email = inputProps.initialEmail;})
  let warningState, setWarningState = React.useState<string option> None
  let classes = Styles.useStyles()
  Html.div [
    Mui.grid [
      grid.container true
      grid.direction.column
      grid.spacing._2
      grid.children [
        Mui.grid [
          grid.item true
          grid.children [
            Html.text "Please enter contact info."
          ]
        ]
        Mui.grid [
          grid.item true
          grid.children [
            Html.form [
              prop.children [
                let emailHandler emailOption =
                  match emailOption with
                  | Some v -> setState { state with Email = Some v }
                  | None -> inputProps.returnResult None
                Components.EmailAddress.view {| initialValue = inputProps.initialEmail; allowEntry = inputProps.initialEmail.IsNone; isRequired = true; returnResult = emailHandler |}
                Mui.textField [
                  textField.placeholder "First name"
                  textField.variant.outlined
                  textField.margin.normal
                  textField.fullWidth true
                  textField.label "First name"
                  textField.name "FirstName"
                  textField.required true
                  textField.onChange (fun (ev : Browser.Types.Event) -> setState { state with FirstName = strOption !!ev.target?value |> state.FirstName.setValue })
                ]
                Mui.textField [
                  textField.placeholder "Middle name"
                  textField.variant.outlined
                  textField.margin.normal
                  textField.fullWidth true
                  textField.label "Middle name"
                  textField.name "MiddleName"
                  textField.required false
                  textField.onChange (fun (ev : Browser.Types.Event) -> setState { state with MiddleName = strOption !!ev.target?value })
                ]
                Mui.textField [
                  textField.placeholder "Last name"
                  textField.variant.outlined
                  textField.margin.normal
                  textField.fullWidth true
                  textField.label "Last name"
                  textField.name "LastName"
                  textField.required true
                  textField.onChange (fun (ev : Browser.Types.Event) -> setState { state with LastName = strOption !!ev.target?value |> state.LastName.setValue })
                ]
                Components.PhoneNumber.view {| initialValue = None; allowEntry = true; isRequired = true; returnResult = (fun v -> setState { state with Phone = v }) |}
                Html.div [
                  prop.className classes.wrapper
                  prop.children [
                    Mui.button [
                      prop.type'.submit
                      button.fullWidth true
                      button.variant.contained
                      button.color.primary
                      button.children "Submit Contact"
                      button.disabled (state.isValid() |> not)
                      prop.onClick (fun e ->
                        e.preventDefault ()
                        match state.validate() with
                        | Ok v -> inputProps.returnResult (Some v)
                        | Error msg -> setWarningState (Some msg)
                      )
                    ]
                  ]
                ]
                if warningState.IsSome then Html.text warningState.Value else Html.none
              ]
            ]
          ]
        ]
      ]
    ]
  ]
)